/** @jsx jsx */
import { jsx } from 'theme-ui'

import styled from '@emotion/styled'
import theme from '../../gatsby-plugin-theme-ui'
import { css } from '@emotion/core'

export const Space = styled.div`
${p =>
  p.fill &&
  css`
    flex: 1;
  `}
  width: ${p =>
    p.block ? '100%' : typeof p.width === 'number' ? p.width + 'px' : 'auto'};
  height: ${p =>
    typeof p.height === 'number' ? p.height + 'px' : p.height || 'auto'};
  flex-shrink: 0;

  margin-bottom: ${props => props.size && props.theme.space[props.size]};
  border-top: ${props => props.border && `2px solid ${props.theme.colors.tag}`};

  ${p =>
    mobile(css`
      ${typeof p.widthOnMobile === 'number' &&
        css`
          width: ${p.widthOnMobile}px;
        `};

      ${p.heightOnMobile && typeof p.heightOnMobile === 'number'
        ? css`
            height: ${p.heightOnMobile}px;
          `
        : css`
            height: ${p.heightOnMobile};
          `};
    `)};

  ${p =>
    p.fillRow &&
    css`
      flex-grow: 1;
      margin-right: auto;
      margin-left: auto;
    `};

  ${p =>
    p.fillColumn &&
    css`
      flex-grow: 1;
      margin-top: auto;
      margin-bottom: auto;
    `};
`

export const mobile = body => css`
  @media (max-width: ${theme.responsive.small}px) {
    ${body};
  }
`

export const tablet = body => css`
  @media (max-width: ${theme.responsive.medium}px) {
    ${body};
  }
`

export const tabletUp = body => css`
  @media (min-width: ${theme.responsive.medium}px) {
    ${body};
  }
`

export const tabletDown = body => css`
  @media (max-width: ${theme.responsive.medium}px) {
    ${body};
  }
`

export const smDesktop = body => css`
  @media (max-width: ${theme.responsive.large}px) {
    ${body};
  }
`

export const smDesktopUp = body => css`
  @media (min-width: ${theme.responsive.mediumLarge}px) {
    ${body};
  }
`

export const HideOnMobile = styled.div`
  ${mobile(css`
    display: none;
  `)}
`

export const HideOnSmDesktop = styled.div`
  ${smDesktop(css`
    display: none;
  `)}
`

export const HideOnSmDesktopUp = styled.div`
  ${smDesktopUp(css`
    display: none;
  `)}
`

export const HideOnTablet = styled.div`
  ${tablet(css`
    display: none;
  `)}
`

export const HideOnTabletUp = styled.div`
  ${tabletUp(css`
    display: none;
  `)}
`

export const HideOnTabletDown = styled.div`
  ${tabletDown(css`
    display: none;
  `)}
`

export const HideOnDestop = styled.div`
  display: none;
  ${mobile(css`
    display: block;
  `)}
`
